module.exports = __webpack_public_path__ + "static/media/new1.bb081b99.jpg";